import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Link, useDisclosure } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import { getUserIsStaff, getUserRetailerName, getUserRetailerId } from "store/selectors/user";

import { SideNavLinkList } from "components/layout/side-nav";
import { SideNavLink } from "components/layout/side-nav/side-nav-link";
import { RetailerImpersonateModal } from "components/shared/retailer-impersonate-modal";
import { ApiFeatureFlagged } from "hooks/feature-flags";
import "./header-impersonation-box.scss";

const AdminImpersonationBox = ({ retailerId, disclosure, retailerName }) => {
  if (retailerId) {
    const retailer = retailerName ? `: ${retailerName} (${retailerId})` : `Retailer ${retailerId}`;
    return (
      <Alert mb="2" variant="solid" status="info">
        <AlertIcon />
        <AlertDescription>
          <AlertTitle mb="2">Impersonating {retailer}</AlertTitle>
          <Button variant="tertiary" size="sm" onClick={disclosure.onOpen}>
            Change
          </Button>
        </AlertDescription>
      </Alert>
    );
  }
  return (
    <Alert mb="2" variant="top-accent" status="warning" color="gray.800">
      <AlertIcon />
      <AlertDescription ml="auto">
        <Button variant="tertiary" size="sm" onClick={disclosure.onOpen} data-testid="impersonate-retailer-button">
          Choose Retailer
        </Button>
      </AlertDescription>
    </Alert>
  );
};

const HeaderImpersonationBox = ({ showLinks = true, ...rest }) => {
  const isAdmin = useSelector(getUserIsStaff);
  const retailerName = useSelector(getUserRetailerName);
  const retailerId = useSelector(getUserRetailerId);

  const disclosure = useDisclosure();

  // TODO: Issue MRP-2775
  // eslint-disable-next-line unicorn/no-null
  if (!isAdmin)
    // TODO: Issue MRP-2775
    // eslint-disable-next-line unicorn/no-null
    return null;

  return (
    <Box className="header-impersonation-box" {...rest}>
      <RetailerImpersonateModal disclosure={disclosure} />
      <span className="header-impersonation-box__pill">Admin</span>
      <AdminImpersonationBox disclosure={disclosure} retailerId={retailerId} retailerName={retailerName} />

      {showLinks && (
        <SideNavLinkList>
          <SideNavLink as={Link} isExternal href={import.meta.env.VITE_ADMIN_URL}>
            Django
          </SideNavLink>
          <SideNavLink as={Link} isExternal href={import.meta.env.VITE_LEGACY_ADMIN_URL}>
            Legacy
          </SideNavLink>
          <SideNavLink to="/search" >
                    Max Search 2.0
                    </SideNavLink>
          <SideNavLink to="/admin/verifications">Admin</SideNavLink>
          <ApiFeatureFlagged featureName="retailers.pim.show-admin-link">
            <SideNavLink to="/admin/pim/">PIM</SideNavLink>
          </ApiFeatureFlagged>
        </SideNavLinkList>
      )}
    </Box>
  );
};

export default HeaderImpersonationBox;
